import FinancesPage from './FinancesPage';

export default FinancesPage;
